import { Component, } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { PageTile } from './../../models/pagetiles/pagetiles.model';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-tiles-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html', // TODO: tile list template
})
export class TilesListComponent extends ListBase<PageTile> {

  public url = 'pagetiles';
  public routePrefix = 'tiles';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
